import ApiService from '@/api';
import CheckNamespaceAdminRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/namespace-admins/CheckNamespaceAdminRequest';
import CheckProjectAdminRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/project-admins/CheckProjectAdminRequest';
import GetCountEmployeesUserRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/request/GetCountEmployeesUserRequest';
import { ResponseModel } from '@/models';
import { CurrentUser } from 'tir-pm-user-core';
import { CheckRouteRequestModel } from './models';
import { mapCheckRouteRequestModel } from './AdapterServiceMappers';

/**Сервис для отправки запросов */
export class MiddlewareAdapterService {
  /**API сервис */
  api = new ApiService();

  /**Проверка на админа проекта */
  CheckProjectAdmin(projectId: number) {
    return new Promise<ResponseModel<boolean>>((resolve) => {
      const result = new ResponseModel<boolean>();
      this.api.Main.ProjectAdminRoleService.checkProjectAdminAsync(
        new CheckProjectAdminRequest({
          ProjectId: projectId,
          UserId: CurrentUser.Id,
        }),
      )
        .then((response) => {
          result.Value = response.IsProjectAdmin;
          return resolve(result);
        })
        .catch(() => {
          result.IsSuccess = false;
          return resolve(result);
        });
    });
  }
  /**Проверка на админа области */
  CheckNamespaceAdmin(namespaceId: string) {
    return new Promise<ResponseModel<boolean>>((resolve) => {
      const result = new ResponseModel<boolean>();
      this.api.Main.NamespaceAdminRoleService.checkNamespaceAdminAsync(
        new CheckNamespaceAdminRequest({
          NamespaceId: namespaceId,
          UserId: CurrentUser.Id,
        }),
      )
        .then((response) => {
          result.Value = response.IsNamespaceAdmin;
          return resolve(result);
        })
        .catch(() => {
          result.IsSuccess = false;
          return resolve(result);
        });
    });
  }
  /**Метод для проверка роута */
  checkRouteAsync(request: CheckRouteRequestModel): Promise<ResponseModel<Boolean>> {
    return new Promise<ResponseModel<Boolean>>((resolve) => {
      const result = new ResponseModel<Boolean>();

      this.api.Main.ProjectGroupService.checkRouteAsync(mapCheckRouteRequestModel(request))
        .then((response) => {
          result.Value = response;
          return resolve(result);
        })
        .catch(() => {
          result.IsSuccess = false;
          return resolve(result);
        });
    });
  }
  /**Получение количества человек в команде пользователя */
  GetCountEmployeesUser() {
    return new Promise<ResponseModel<number>>((resolve) => {
      const result = new ResponseModel<number>();
      this.api.Main.EmployeeService.getCountEmployeesUserAsync(
        new GetCountEmployeesUserRequest({ UserId: CurrentUser.Id }),
      )
        .then((response) => {
          result.Value = response.Count;
          return resolve(result);
        })
        .catch(() => {
          result.IsSuccess = false;
          return resolve(result);
        });
    });
  }
}
